import React from "react";

export default function BouncingLoader() {
  return (
    <div className="w-full flex justify-center mt-6 mb-6">
      <img
        src="/images/post-image.png"
        alt=""
        className="animate-bounce w-12 h-12"
      />
    </div>
  );
}
